import { useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';
import { LoadingPane } from '~/components/loading-pane';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { ShowPreviewDocument } from '../queries/preview.generated';
import { Layout } from './components/layout';
import { ShowPreview } from './components/preview';

export const ShowPreviewPage = () => {
  const { currentNetwork } = useAppContext();
  const link = useLink();

  const params = useParams<{ showId: string }>();
  const showId = parseInt(params.showId ?? '');

  const { data, loading } = useQuery(ShowPreviewDocument, {
    fetchPolicy: 'cache-first',
    variables: { networkId: currentNetwork.id, showId },
  });

  const show = data?.network?.show;

  if (!loading && !data?.network?.show) return <Navigate to={link('/not-found')} replace />;

  return (
    <LoadingPane in={loading && !data}>
      {show && (
        <Layout>
          <ShowPreview show={show} />
        </Layout>
      )}
    </LoadingPane>
  );
};
